import {supplierquestionnaire} from '../services'
import {fetch as fetchRaw} from '@lib/fetch'
import {getDefinedUrlSearchParams} from '@lib/util'
import * as constants from '@constants'

const fetch = (url, ...args) => fetchRaw([supplierquestionnaire.url, url], ...args)

export const getQuestionnaires = queryParams => {
  return fetch(`/v1/questionnaires?${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export const postQuestionnaires = body => {
  return fetch(`/v1/questionnaires`, {method: 'POST', body: JSON.stringify(body)})
}

export const patchQuestionnaires = (id, body) => {
  return fetch(`/v1/questionnaires/${id}`, {method: 'PATCH', body: JSON.stringify(body)})
}

export const getQuestionnaire = id => {
  return fetch(`/v1/questionnaires/${id}`, {method: 'GET'})
}

export const bulkDeleteQuestionnaire = body => {
  return fetch(`/v1/questionnaires`, {method: 'DELETE', body: JSON.stringify(body)})
}

export const bulkArchiveQuestionnaire = body => {
  return fetch(`/v1/questionnaires/archive`, {method: 'POST', body: JSON.stringify(body)})
}

export const bulkUnArchiveQuestionnaire = body => {
  return fetch(`/v1/questionnaires/unarchive`, {method: 'POST', body: JSON.stringify(body)})
}

export const getRetracedQuestionnaires = queryParams => {
  return fetch(`/v1/admin/templates?${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export const patchQuestionnaireBuilder = (id, body) => {
  return fetch(`/v1/questionnaires/builder/${id}`, {method: 'PUT', body: JSON.stringify(body)})
}

export const getQuestionnaireBuilder = id => {
  return fetch(`/v1/questionnaires/builder/${id}`, {method: 'GET'})
}

export function getDataPointsByTemplates() {
  return fetch(`/v1/data-points?groupByTemplates=true`, {method: 'GET'})
}

export const getDataPoints = () => {
  return fetch(`/v1/data-points`, {method: 'GET'})
}

export const bulkRequest = body => {
  return fetch(`/v1/questionnaires/requests`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function questionnaireRequestGet(id) {
  return fetch(`/v1/questionnaires/requests/${id}`, {
    method: 'GET',
  })
}

export function questionnaireAnswerGetById(requestId, questionId) {
  return fetch(`/v1/responses/requests/${requestId}/questions/${questionId}`, {
    method: 'GET',
  })
}

export function answerQuestionnaire(body) {
  return fetch(`/v1/responses`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function questionnaireRequestUpdateState(responseId, body) {
  return fetch(`/v1/questionnaires/requests/${responseId}/status`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function questionnaireFormQuestionCommentsGet(requestId, questionId) {
  return fetch(`/v1/questions/comments/${questionId}/requests/${requestId}`, {
    method: 'GET',
  })
}

export function questionnaireFormQuestionCommentAdd(body) {
  return fetch(`/v1/questions/comments`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function deleteComment(id) {
  return fetch(`/v1/questions/comments/${id}`, {
    method: 'DELETE',
  })
}

export function updateComment(id, body) {
  return fetch(`/v1/questions/comments/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function getCompanyDataPointAnswer(dataPointId, companyId) {
  return fetch(`/v1/data-points/${dataPointId}/companies/${companyId}`, {
    method: 'GET',
  })
}

export function questionnaireQuestionGet(requestId, companyId, questionId) {
  return fetch(`/v1/responses/requests/${requestId}/questions/${questionId}`, {
    method: 'GET',
  })
}

export function questionnaireApproveQuestionAnswer(responseId, questionId, requestCompanyId) {
  return fetch(`/v1/responses/requests/${responseId}/questions/${questionId}`, {
    method: 'PATCH',
    body: JSON.stringify({status: constants.questionnaireResponseAnswerStatus.enumMapping.APPROVED}),
  })
}
export function questionnaireDenyQuestionAnswer(responseId, questionId, requestCompanyId) {
  return fetch(`/v1/responses/requests/${responseId}/questions/${questionId}`, {
    method: 'PATCH',
    body: JSON.stringify({status: constants.questionnaireResponseAnswerStatus.enumMapping.DENIED}),
  })
}

export function questionnaireCompaniesGet(id, queryParams) {
  return fetch(`/v1/questionnaires/${id}/requests?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRequestsForQuestionnaire(id, queryParams) {
  return fetch(`/v1/questionnaires/${id}/requests?${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export function getMyQuestionnaireRequests(queryParams) {
  return fetch(`/v1/requests?${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export function getRequestsByCompanyId(companyId, queryParams) {
  return fetch(`/v1/requests?companyId=${companyId}&${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export function bulkUpdateDueDate(body) {
  return fetch(`/v1/questionnaires/requests/due-date`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function bulkDeleteRequests(body) {
  return fetch(`/v1/questionnaires/requests`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  })
}

export function notifyReminder(body) {
  return fetch(`/v1/questionnaires/requests/reminder`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function saveQuestionnaireAsTemplate(id) {
  return fetch(`/v1/questionnaires/${id}/save-as-template`, {
    method: 'POST',
  })
}

export function duplicateTemplate(id) {
  return fetch(`/v1/templates/${id}/copy`, {
    method: 'POST',
  })
}

export function duplicateRetracedTemplate(id) {
  return fetch(`/v1/admin/templates/${id}/copy`, {
    method: 'POST',
  })
}

export const getQuestionnaireTemplates = queryParams => {
  return fetch(`/v1/templates?${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export const createQuestionnaireTemplate = body => {
  return fetch(`/v1/templates`, {method: 'POST', body: JSON.stringify(body)})
}

export const getQuestionnaireTemplate = id => {
  return fetch(`/v1/templates/${id}`, {method: 'GET'})
}

export const patchQuestionnaireTemplates = (id, body) => {
  return fetch(`/v1/admin/templates/${id}`, {method: 'PATCH', body: JSON.stringify(body)})
}

export const updateQuestionnaireTemplate = (id, body) => {
  return fetch(`/v1/templates/${id}`, {method: 'PUT', body: JSON.stringify(body)})
}

export const bulkDeleteQuestionnaireTemplates = body => {
  return fetch(`/v1/templates`, {method: 'DELETE', body: JSON.stringify(body)})
}

export const createRetracedQuestionnaireTemplate = body => {
  return fetch(`/v1/admin/templates`, {method: 'POST', body: JSON.stringify(body)})
}

export const getRetracedQuestionnaireTemplate = id => {
  return fetch(`/v1/admin/templates/${id}`, {method: 'GET'})
}

export const updateRetracedQuestionnaireTemplate = (id, body) => {
  return fetch(`/v1/admin/templates/${id}`, {method: 'PUT', body: JSON.stringify(body)})
}

export const bulkDeleteRetracedQuestionnaireTemplates = body => {
  return fetch(`/v1/admin/templates`, {method: 'DELETE', body: JSON.stringify(body)})
}

export const exportRequests = (id, body) => {
  return fetch(`/v1/questionnaires/${id}/export`, {method: 'POST', body: JSON.stringify(body)})
}
